import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../../models/payload";
import { IRequestDetails } from "../../../../models/requestDetails";

interface IDetailRequestFormState {
    form: IRequestDetails;
    isLoaded: boolean;
    showPopUp: string;
    loading: boolean;
}

const initialState: IDetailRequestFormState = {
    form: {
        dockCode: "",
        dockDescription: "",
        dockEndOn: "",
        dockStartOn: "",
        entryOn: "",
        date: "",
        newSeals: [],
        originSeals: [],
        stateDescription: "",
        stateSort: 0,
        transportUnitNumber: "",
    },
    isLoaded: false,
    showPopUp: "",
    loading: false,
};

export const detailsRequestFormReducer = createSlice({
    name: "detailsRequestFormReducer",
    initialState,
    reducers: {
        resetDetailsRequestForm: () => initialState,
        updateDetailsRequestProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.form = {
                ...state.form,
                [action.payload.name]: action.payload.value,
            };
        },
        setDetailsRequestShowPopUp: (state, action: PayloadAction<string>) => {
            state.showPopUp = action.payload;
        },

        setLoadingRequestDetails: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        setIsLoadedRequestDetail: (state, action: PayloadAction<boolean>) => {
            state.isLoaded = action.payload;
        },
        setRequestDetailsFormData: (state, action: PayloadAction<IRequestDetails>) => {
            state.form = action.payload;
        },
    },
});

export const {
    resetDetailsRequestForm,
    setDetailsRequestShowPopUp,
    updateDetailsRequestProperty,
    setLoadingRequestDetails,
    setRequestDetailsFormData,
    setIsLoadedRequestDetail,
} = detailsRequestFormReducer.actions;

export default detailsRequestFormReducer.reducer;
